import { createRouter, createWebHistory } from 'vue-router'
import MainLayout from '@/layouts/MainLayout.vue'

export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      component: MainLayout,
      children: [
        { path: '', name: 'home', component: () => import('@/views/HomeView.vue') },
        { path: 'calendar', name: 'calendar', component: () => import('@/views/CalendarView.vue') },
        { path: 'records', name: 'records', component: () => import('@/views/RecordsView.vue') },
        { path: 'stats', name: 'stats', component: () => import('@/views/StatsView.vue') },
        { path: 'mine', name: 'mine', component: () => import('@/views/MineView.vue') }
      ]
    },
    { path: '/entry/new/:type', name: 'entry-new', component: () => import('@/views/EntryEditorView.vue') },
    { path: '/entry/:id/edit', name: 'entry-edit', component: () => import('@/views/EntryEditorView.vue') },
    { path: '/entry/:id', name: 'entry-detail', component: () => import('@/views/EntryDetailView.vue') },
    { path: '/habits', name: 'habits', component: () => import('@/views/HabitsView.vue') },
    { path: '/:pathMatch(.*)*', redirect: '/' }
  ],
  scrollBehavior: () => ({ top: 0 })
})
